import axios from '@/libs/api.request'

export const getList = async (that, data) => {
    let res = await axios.request({
        url: '/shop/verify_code_record/getList',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({ name: 'login' });
        }
        return;
    }
    return res;
}
